/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idLead: string | undefined;
  numeroCotacao: string;
  anexo?: null;
}

export function useVincularOportunidade(props: Props) {
  const postData = async () => {
    const INSERIR_OPORTUNIDADE = `${backofficeEnviroment}/common/oportunidades-lead/v1`;
    const { data } = await instance.post(INSERIR_OPORTUNIDADE, {
      idLead: props.idLead,
      numeroCotacao: props.numeroCotacao,
      anexo: props.anexo,
    });
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: () => {
      toast.success("Vinculado com sucesso!");
    },
    onError: (error: any) => {
      toast.error(
        `Erro ao vincular Proposta. Motivos: ${error.response.data.notifications.map(
          (item: any) => item?.message
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return mutation;
}
